module.exports = __webpack_public_path__ + "static/media/lr.309ccbd8.svg";